"use strict";
'use es6';

/**
 * Returns `true` if `subject` is `null`.
 *
 * @param  {any}  subject
 * @return {boolean}
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNull;
function isNull(subject) {
  return subject === null;
}
module.exports = exports.default;